import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFocusMacro: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="focus-macro"><path d="M3.75 8V3.75H8M3.75 16V20.25H8M16 3.75H20.25V8M20.25 16V20.25H16M12 14.25V16.25M8.75 8.55208V10.9896C8.75 12.7845 10.2051 14.2396 12 14.2396C13.7949 14.2396 15.25 12.7845 15.25 10.9896V8.55208L13.3542 9.36458L12 8.01042L10.6458 9.36458L8.75 8.55208Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFocusMacro;
